import {MenuItem} from '@/components/ui/menu-atoms/MenuAtoms.tsx'
import {RefreshCw01Icon} from '@/components/ui/icon/Icon.tsx'
import {useTranslation} from '@/translations/i18n.tsx'
import {Access} from '../../types'
import {useUpdateAccess} from '../../queries/useUpdateAccess'
import {toast} from '@/utilities/toast/toast'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {MUTATION_KEYS} from '@/queryClient'
import {useIsMutating, useQueryClient} from '@tanstack/react-query'
import {invalidateAccessesTableOnly, updateAccessStatusInSignatureSheetsCache} from '../../cacheUtils'

export const RestoreAccessButton = ({access}: {access: Access}) => {
    const {t} = useTranslation()
    const queryClient = useQueryClient()
    const {mutate: updateAccess, isPending: isUpdating} = useUpdateAccess(
        {accessId: access.id},
        {
            onSuccess: () => {
                invalidateAccessesTableOnly(queryClient)
                updateAccessStatusInSignatureSheetsCache(queryClient, access.id, 'to_validate')
                toast.success(t('accesses:restore_discarded_access_success'))
            }
        }
    )
    const isMutating = useIsMutating({mutationKey: [MUTATION_KEYS.UPDATE_ACCESS, access.id]})

    return (
        <MenuItem
            hideOnClick={false}
            disabled={isUpdating || isMutating > 0}
            onClick={e => {
                e.stopPropagation()
                e.preventDefault()
                updateAccess({
                    status: 'to_validate'
                })
            }}
        >
            {isUpdating ? <Spinner /> : <RefreshCw01Icon />}
            {t('accesses:restore_discarded_access')}
        </MenuItem>
    )
}
